// extracted by mini-css-extract-plugin
module.exports = {"content":"info-module--content--2RogH"};